var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unknown-error-page"},[_c('alert-page',{attrs:{"img":require('@/assets/generic-faliure.png'),"title":'משהו לא עובד כרגע...',"showButton":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._v("\n        אפשר לנסות לרענן את העמוד או לחזור שוב מאוחר יותר.\n    ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }